import React, { useState, useEffect } from 'react';
import * as FieldTypes from "./FieldTypes.js";

const UDIDateField = ({
    UDI,
    setUDI,
    fieldTitle,
    fieldName,
    forceIsEditing = null
}) => {

    const formatDate = (date) => {
        try {

            if (date === null || date === "")
                return "";

            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const day = String(d.getDate()).padStart(2, '0');
    
            return `${year}-${month}-${day}`;
        }
        catch (ex) {
            return "";
        }

    };

    const date = formatDate(UDI?.[fieldName]);

    const [errorVar, setErrorVar] = useState(false);
    const [isEditingField, setIsEditingField] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [value, setValue] = useState(date);

    const handleChange = (e) => {
        let newValue = e.target.value;
        setValue(newValue);

        setUDI(prevItem => ({
            ...prevItem,
            [fieldName]: newValue
        }));
    }



    
    
    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);

    }, [forceIsEditing]);

    


    return (
        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    {isEditingField === false ? (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <span
                                    className={`editable-field-span ${errorVar ? "form-field-error" : ""}`}
                                    onClick={() => changeIsEditingField(true)}
                                >
                                    {value === "" ? 
                                        <FieldTypes.ItemDetailsField_EmptyValue /> 
                                        : 
                                        value
                                    }
                                </span>
                            </div>

                            {errorVar && (
                                <span className="form-field-error-message">
                                    The field {fieldTitle} is necessary
                                </span>
                            )}
                        </div>
                    ) : (
                        <span>
                            <input
                                type="date"
                                className="form-control"
                                onBlur={() => changeIsEditingField(false)}
                                onChange={handleChange}
                                value={value}
                                autoFocus={forceIsEditing != null ? false : true}
                            />
                        </span>
                    )}

                </div>
            </div>
        </div>
    );
}

export default UDIDateField;